import ArrowLinkButton from '@/component/common/arrow-link-button';
import RandomKeypad from '@/component/common/random-keypad';
import SecretNumberDisplay from '@/component/common/secret-number-display';
import SFStepper from '@/component/common/sf-stepper';
import TopBackButton from '@/component/common/top-back-button';
import SFCopyIcon from '@/component/icons/sf-copy-icon';
import AddSecureDrawer from '@/component/auth/add-secure-drawer';
import { SFPalette } from '@/lib/color';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const DUMMY = {
  inviteCode: 'KAFFSES',
};

export default function WellcomePage() {
  const navigate = useNavigate();

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Container maxWidth="sm">
      <Box position="sticky" top={0} bgcolor="white" zIndex={100}>
        <TopBackButton
          title="회원가입"
          useBackButton={false}
          boxProps={{
            mb: 2,
          }}
        />
        <SFStepper
          steps={['1', '2', '3', '4']}
          activeStep={3}
          stepperProps={{
            sx: {
              width: 200,
              ml: '-10px',
              pb: 2,
            },
          }}
        />
      </Box>
      <Box pt={4}>
        <Box>
          <Typography variant="h4" mb={2.5}>
            <b>회원가입</b>이 <b>완료</b>되었습니다!
          </Typography>
          <ArrowLinkButton
            onClick={() => {
              navigate('/signInSns');
              setOpenDrawer(true);
            }}
          >
            로그인하고 셔플 둘러보기
          </ArrowLinkButton>
        </Box>
        {/* TODO 서버 로직 변경 후 적용 */}
        {/* <Divider
          sx={{
            my: 5,
          }}
        />
        <Box>
          <Typography variant="body1" mb={1} fontWeight={700}>
            나의 추천인 코드
          </Typography>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            py={2}
            px={2.5}
            mb={1.5}
            bgcolor={SFPalette.lightGrey3}
            borderRadius={2}
          >
            <Typography variant="body1" fontWeight={500}>
              {DUMMY.inviteCode}
            </Typography>
            <IconButton
              sx={{
                p: 0.5,
              }}
              onClick={() => {
                navigator.clipboard.writeText(DUMMY.inviteCode);
                toast.success('추천인 코드가 클립보드에 복사되었습니다.');
              }}
            >
              <SFCopyIcon color={SFPalette.lightGrey2} />
            </IconButton>
          </Stack>
          <Typography variant="body1" color={SFPalette.grey4}>
            {'친구에게 셔플을 소개해 주세요:)'}
            <br />
            가입 시{' '}
            <b
              style={{
                color: SFPalette.shuffleColor2,
              }}
            >
              1,000셔플 포인트
            </b>
            를 즉시 지급해 드려요!
          </Typography>
        </Box> */}
      </Box>
      <AddSecureDrawer
        open={openDrawer}
        onClose={() => {
          setOpenDrawer(false);
        }}
      />
    </Container>
  );
}
